.frame {
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: 45;
  border: 8px solid;
}
.warning {
  border-color: var(--color-warning);
  box-shadow: inset 0 0 70px rgba(217, 119, 6, 0.18);
  animation: evx-pulse 1.8s ease-in-out infinite;
}
.danger {
  border-color: var(--color-danger);
  box-shadow: inset 0 0 70px rgba(220, 38, 38, 0.18);
  animation: evx-pulse 1.3s ease-in-out infinite;
}
